export default {
    ENV: "production",
    BASIC_AUTH_USERNAME:"devmonkey",
    BASIC_AUTH_PASSOWRD:"d3Vm0nK3y",
    API_URL: "https://www.efficientlearning.com",
    SWIFT_TYPE_ENGINE_ID: "A4CCJVhm6ZyThQUtd2hS",
    SWIFT_TYPE_ENGINE_KEY: "esrcPNik3VsMgKNgyeVg"
};